import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import OceanNav from "../components/ocean/OceanNav";
import OceanHero from "../components/ocean/OceanHero";
import OceanMarquee from "../components/ocean/OceanMarquee";
import WhyOcean from "../components/ocean/WhyOcean";
import RegionsMap from "../components/ocean/RegionsMap";
import OceanWorkProgramme from "../components/ocean/OceanWorkProgramme";
import OceanTechnology from "../components/ocean/OceanTechnology";
import OceanRoadmap from "../components/ocean/OceanRoadmap";
import Safety from "../components/ocean/Safety";
import OceanPartnerships from "../components/ocean/OceanPartnerships";
import JoinExpedition from "../components/ocean/JoinExpedition";
import OceanUpdatesPreview from "../components/ocean/OceanUpdatesPreview";
import OceanClosing from "../components/ocean/OceanClosing";

const REDUCED = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function Ocean() {
  const [booted, setBooted] = useState(REDUCED);

  useEffect(() => {
    document.title = "Arjuna Indian Ocean Expedition · Dive India. Map Tomorrow.";
    if (REDUCED) return undefined;
    const t = setTimeout(() => setBooted(true), 1600);
    return () => clearTimeout(t);
  }, []);

  return (
    <main data-testid="ocean-page" className="bg-onavy">
      <AnimatePresence>
        {!booted && (
          <motion.div
            className="fixed inset-0 z-[100] bg-onavy flex flex-col items-center justify-center"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid="ocean-boot-loader"
          >
            <div className="font-mono text-[10px] tracking-[0.4em] text-oreef mb-3">ARJUNA SPACE AI INDIA</div>
            <div className="font-display font-bold text-2xl sm:text-3xl text-oseaglass tracking-[0.15em] uppercase">Indian Ocean Expedition</div>
            <div className="mt-8 w-56 h-px bg-oreef/15 relative overflow-hidden">
              <motion.div className="absolute inset-y-0 left-0 bg-ocoral" initial={{ width: "0%" }} animate={{ width: "100%" }} transition={{ duration: 1.3, ease: "easeInOut" }} />
            </div>
            <div className="mt-4 font-mono text-[9px] tracking-[0.3em] text-oslate">ARABIAN SEA · BAY OF BENGAL · DESCENDING</div>
          </motion.div>
        )}
      </AnimatePresence>

      <OceanNav />
      <OceanHero booted={booted} />
      <OceanMarquee />
      <WhyOcean />
      <RegionsMap />
      <OceanWorkProgramme />
      <OceanTechnology />
      <OceanRoadmap />
      <Safety />
      <OceanPartnerships />
      <JoinExpedition />
      <OceanUpdatesPreview />
      <OceanClosing />
    </main>
  );
}
